export default class ButtonElement {
  constructor(options) {
    this.elem = options.element;
    this.$elem = $(options.element);
    this.learnEditor = options.editor ? options.editor : null;

    this.editorEnabled = false;
    this.savedTitleText = '';
    this.savedLinkText = '';
    this.savedButtonColor = '';
    this.savedTarget = '';
    this.savedZipFolder;
    this.activeElementId;
    this.activePosition;

    this.templates = {
      "addButton": "<a id='add-build-button' class='button secondary editor-add-button' href=''><i class='fa fa-external-link'></i> Button</a>",
      "buttonEditor":  "<div class='row-fluid editor-add-button-wrapper'>" +
                          "<label>Choose button type</label>" +
                          "<div class='editor-add-colors btn-group'>" +
                            "<button type='button' class='btn-danger editor-button'>Danger</button>" +
                            "<button type='button' class='btn-primary active editor-button'>Primary</button>" +
                            "<button type='button' class='btn-info editor-button'>Info</button>" +
                            "<button type='button' class='btn-warning editor-button'>Warning</button>" +
                          "</div>" +
                          "<label for='button-title'>Enter button title</label>" +
                          "<input name='button-title' class='build-input editor-add-button-title span12' style='display=block;'>" +
                          "<label for='button-link'>Enter button link</label>" +
                          "<input name='button-link' class='build-input editor-add-button-link span12' style='display=block;'>" +

                          "<p class='help'>Format example for latest release tracking: https://github.com/adafruit/Adafruit_Windows_Drivers/releases/latest/adafruit_drivers*.exe</p>" +
                          "<div class='editor-add-button-target'>" +
                            "<label><input type='checkbox' id='button-target' name='target' /> Open in new window</label>" +
                          "</div>" +
                          "<div class='editor-add-button-zip-folder' style='display:none;'>" +
                            "<label><input type='checkbox' id='button-zip-folder' name='target'> Zip this Folder</label>" +
                          "</div>" +
                          "<div class='editor-buttons'>" +
                            "<button class='editor-add-button-delete delete'>Delete</button>" +
                            "<button class='editor-add-button-cancel cancel'>Cancel</button>" +
                            "<button class='editor-add-button-submit save'>Save</button>" +
                          "</div>" +
                        "</div>",
      "buttonElement": "<div class='element button-element build-button'>" +
                          "<a href='' class='btn btn-large btn-block btn-primary' type='button'></a>" +
                        "</div>"
    };

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on(action, '.add-build-button', this.appendButton.bind(this));
    $(document).on(action, '.build-button', this.editExistingButton.bind(this));
    $(document).on(action, '.editor-add-button-submit', this.saveButtonHandler.bind(this));
    $(document).on(action, '.editor-add-button-cancel', this.cancelButtonHandler.bind(this));
    $(document).on(action, '.editor-add-button-delete', this.deleteButtonHandler.bind(this));
    $(document).on('keyup', '.editor-add-button-link', this.watchInputButtonLink.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-button" href="#"><i class="fa fa-external-link"></i>Button</a>';
  }

  appendButton(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $element = $(event.target).closest('.button-bar, .bottom-button-bar');

    $element.hide();
    var $buttonEditor = $(this.templates.buttonEditor).hide();
    $element.replaceWith($buttonEditor);
    $buttonEditor.show();

    this.learnEditor.center_in_view($buttonEditor);
    this.learnEditor.editing();
    // this.enableButtonEditor();
  }

  editExistingButton(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $element = $(event.target).closest('.button-element')
    var title = $('a', $element).text();
    var link = $('a', $element).attr('href');
    var buttonColor = $('a', $element).attr('class').replace('btn btn-large btn-block ', '');
    var target = $('a', $element).attr('target');
    var zipFolder = $('a', $element).attr('data-zip-folder');

    this.savedTitleText = title;
    this.savedLinkText = link;
    this.savedButtonColor = buttonColor;
    this.savedTarget = target;
    this.savedZipFolder = zipFolder;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');

    var $buttonEditor = $(this.templates.buttonEditor);
    $buttonEditor.find('.editor-add-button-title').val(title);
    $buttonEditor.find('.editor-add-button-link').val(link);
    $buttonEditor.find('.editor-add-colors button').removeClass('active');
    $buttonEditor.find('.editor-add-colors .' + buttonColor).addClass('active');
    if (target === "_blank") {
      $buttonEditor.find('#button-target').prop("checked", true);
    }

    if (zipFolder === "true") {
      $buttonEditor.find('#button-zip-folder').prop("checked", true);
    }

    $element.replaceWith($buttonEditor);

    this.displayZipFolderOption(link);

    this.learnEditor.center_in_view($('.editor-add-button-wrapper'));
    this.learnEditor.editing();
  }

  saveButtonHandler(event) {
    event.preventDefault();

    let title = $('.editor-add-button-title').val();
    let link = $('.editor-add-button-link').val();
    let color = 'btn-' + $('.editor-add-colors .active').text().toLowerCase();
    let target = $('#button-target').is(':checked') ? "_blank" : "_self";
    let zipFolder = $('#button-zip-folder').is(':checked');

    this.createButtonElement(title, link, color, target, zipFolder);
    this.learnEditor.save_page("Before Big Button Modified");
  }

  cancelButtonHandler(event) {
    event.preventDefault();

    if (this.savedTitleText) {
      this.createButtonElement(this.savedTitleText, this.savedLinkText, this.savedButtonColor, this.savedTarget, this.savedZipFolder);
    } else {
      $('.editor-add-button-wrapper').remove();
    }

    this.learnEditor.finishEditing();
  }

  deleteButtonHandler(event) {
    event.preventDefault();

    this.activeElementId = "";
    this.activePosition = "";
    $('.editor-add-button-wrapper').remove();

    this.learnEditor.save_page("Before Big Button Delete");
  }

  watchInputButtonLink(event) {
    let $element = $(event.currentTarget);
    let value = $element.val();

    this.displayZipFolderOption(value);
  }

  displayZipFolderOption(value) {
    if (/github.com\/adafruit\/[\S]+/.test(value)) {
      $('.editor-add-button-zip-folder').show();
    } else {
      $('.editor-add-button-zip-folder').hide();
    }
  }

  createButtonElement(title, link, color, target, zipFolder) {
    var $buttonElement = $(this.templates.buttonElement);
    $buttonElement.attr('id', (this.activeElementId || "")).data('position', this.activeElementId);
    this.activeElementId = "";
    this.activePosition = "";

    var $buttonLink = $buttonElement.find('a');
    $buttonLink.removeClass('btn-primary btn-info btn-warning btn-danger');
    $buttonLink.attr('href', link).text(title).addClass(color);
    $buttonLink.attr('target', target);
    $buttonLink.attr('data-zip-folder', zipFolder);


    $('.editor-add-button-wrapper').replaceWith($buttonElement);
  }
}
